import { Component, Input } from '@angular/core';
import { PriceConfigService } from 'gung-standard';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'otto-olsen-price-list-display',
  templateUrl: './otto-olsen-price-list-display.component.html',
  styleUrls: ['./otto-olsen-price-list-display.component.scss']
})
export class OttoOlsenPriceListDisplayComponent {

  @Input() price;
  @Input() product;

  public Number = (n) => Number(n);

  protected unsubscribe: Subject<void> = new Subject();
  public hidePrice: boolean;

  constructor(
    protected priceConfigService: PriceConfigService
  ) { }
  ngOnInit() {

    this.priceConfigService.hidePrice.pipe(takeUntil(this.unsubscribe)).subscribe(hidePrice => (this.hidePrice = hidePrice));
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
